let apiBaseUrl: string;

if (process.env.REACT_APP_ENV === 'production') {
  apiBaseUrl = 'https://seismic-pursuit-354906.df.r.appspot.com/api';
} else if (process.env.REACT_APP_ENV === 'development') {
  apiBaseUrl = 'https://staging-dot-seismic-pursuit-354906.df.r.appspot.com/api';
} else {
  apiBaseUrl = 'http://localhost:5001/api';
}

export const API_BASE_URL = apiBaseUrl;